// <form class="validate_form">                            // Use Class (validate_form) to use validation in form
// <div class="field validate_${input_value}">             // Use (validate_f_name, validate_l_name, validate_email, validate_passowrd) different classes for different input values
// <input type="text">
// </div>
// <button class="submit_button"></button>
// </form>

$(document).ready(function () {
  var validate_name = /^[A-Za-z]+$/;
  var validate_email = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
  var validate_password = /^.{8,20}$/;
  $("form button").click(function () {
    $("form").removeClass("form_submitted");
    $(this).parents("form").addClass("form_submitted");
    if (
      typeof $(".form_submitted .validate_f_name input").val() == "undefined"
    ) {
      var f_name = "emptyfname";
    } else {
      var f_name = $(".form_submitted .validate_f_name input").val();
    }

    if (
      typeof $(".form_submitted .validate_l_name input").val() == "undefined"
    ) {
      var l_name = "emptylname";
    } else {
      var l_name = $(".form_submitted .validate_l_name input").val();
    }

    if (
      typeof $(".form_submitted .validate_email input").val() == "undefined"
    ) {
      var email = "emptyemail@validate.com";
    } else {
      var email = $(".form_submitted .validate_email input").val();
    }

    if (
      typeof $(".form_submitted .validate_password input").val() == "undefined"
    ) {
      var password = "validatepassword";
    } else {
      var password = $(".form_submitted .validate_password input").val();
    }
    if (
      typeof $(".form_submitted .validate_confirm_passowrd input").val() ==
      "undefined"
    ) {
      var confirm_password = password;
    } else {
      var confirm_password = $(
        ".form_submitted .validate_confirm_passowrd input"
      ).val();
    }

    !f_name?.length == 0 && validate_name?.test(f_name) == true
      ? $(".form_submitted .validate_f_name").removeClass("error")
      : $(".form_submitted .validate_f_name").addClass("error");

    !l_name?.length == 0 && validate_name?.test(l_name) == true
      ? $(".form_submitted .validate_l_name").removeClass("error")
      : $(".form_submitted .validate_l_name").addClass("error");

    !email?.length == 0 && validate_email?.test(email) == true
      ? $(".form_submitted .validate_email").removeClass("error")
      : $(".form_submitted .validate_email").addClass("error");

    !password?.length == 0 && validate_password?.test(password) == true
      ? $(".form_submitted .validate_password").removeClass("error")
      : $(".form_submitted .validate_password").addClass("error");

    !confirm_password?.length == 0 &&
    validate_password?.test(confirm_password) == true
      ? $(".form_submitted .validate_confirm_passowrd").removeClass("error")
      : $(".form_submitted .validate_confirm_passowrd").addClass("error");

    confirm_password == password
      ? $(".form_submitted .validate_confirm_passowrd").removeClass(
          "same_password_error"
        )
      : $(".form_submitted .validate_confirm_passowrd").addClass(
          "same_password_error"
        );

    if (
      !f_name?.length == 0 &&
      !l_name?.length == 0 &&
      !email?.length == 0 &&
      !password?.length == 0 &&
      !confirm_password?.length == 0 &&
      validate_name?.test(f_name) &&
      validate_name?.test(l_name) &&
      validate_email?.test(email) &&
      validate_password?.test(password) &&
      validate_password?.test(confirm_password) &&
      confirm_password == password
    ) {
      return;
    } else {
      return false;
    }
  });
});
